// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Modal Overlay */
.modal-overlay[data-v-3f1713c3] {
  z-index: 150;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
}

/* Modal Form */
.modal-form[data-v-3f1713c3] {
  z-index: 200;
  position: fixed;
  top: 5%;
  left: 50%;
  max-width: 300px;
  width: 100%;
  min-height: fit-content;
  max-height: 90vh; /* Prevent modal from exceeding viewport height */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  pointer-events: unset;
  opacity: 0; /* Initially hidden for animation */
  transform: translateY(-50px) translateX(-50%);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Smooth Slide Animation */
.animate-modal[data-v-3f1713c3] {
  opacity: 1; /* Fade in */
  transform: translateY(0) translateX(-50%); /* Slide in from top */
}

/* Modal Sizes */

/* Small modal */
.modal-sm[data-v-3f1713c3] {
  max-width: 300px;
}

/* Medium modal */
.modal-md[data-v-3f1713c3] {
  max-width: 500px;
}

/* Large modal */
.modal-lg[data-v-3f1713c3] {
  max-width: 800px;
}

/* Extra large modal */
.modal-xl[data-v-3f1713c3] {
  max-width: 1000px;
}

/* Extra extra large modal */
.modal-xxl[data-v-3f1713c3] {
  max-width: 1200px;
}

/* Full screen modal */
.modal-full[data-v-3f1713c3] {
  max-width: calc(100% - 15px);
  height: auto;
}

/* Media queries to adjust modal sizes based on viewport width */
@media (min-width: 576px) {
.modal-sm[data-v-3f1713c3] {
    max-width: 400px; /* Adjust width for small devices */
}
}
@media (min-width: 992px) {
.modal-lg[data-v-3f1713c3] {
    max-width: 1000px; /* Adjust width for large devices */
}
}
@media (min-width: 1200px) {
.modal-xl[data-v-3f1713c3] {
    max-width: 1200px; /* Adjust width for extra large devices */
}
}
@media (min-width: 1400px) {
.modal-xxl[data-v-3f1713c3] {
    max-width: 1400px; /* Adjust width for extra extra large devices */
}
}

/* Scrollable Content */
.modal-body[data-v-3f1713c3] {
  flex: 1; /* Makes the body grow as needed */
  overflow-y: auto; /* Enables scrolling if content is too large */
  max-height: calc(90vh - 120px); /* Adjust for header and footer */
}

/* Footer */
.modal-footer[data-v-3f1713c3] {
  border-top: 1px solid #e9ecef;
}

/* Responsive Adjustments */
@media (max-width: 576px) {
.modal-form[data-v-3f1713c3] {
    width: 90%;
    top: 10%;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/Modal/Modal.vue"],"names":[],"mappings":";AAwFA,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;AACT;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,eAAe;EACf,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gBAAgB,EAAE,iDAAiD;EACnE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,UAAU,EAAE,mCAAmC;EAC/C,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA,2BAA2B;AAC3B;EACE,UAAU,EAAE,YAAY;EACxB,yCAAyC,EAAE,sBAAsB;AACnE;;AAEA,gBAAgB;;AAEhB,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA,gEAAgE;AAChE;AACE;IACE,gBAAgB,EAAE,mCAAmC;AACvD;AACF;AAEA;AACE;IACE,iBAAiB,EAAE,mCAAmC;AACxD;AACF;AAEA;AACE;IACE,iBAAiB,EAAE,yCAAyC;AAC9D;AACF;AAEA;AACE;IACE,iBAAiB,EAAE,+CAA+C;AACpE;AAEF;;AAEA,uBAAuB;AACvB;EACE,OAAO,EAAE,kCAAkC;EAC3C,gBAAgB,EAAE,8CAA8C;EAChE,8BAA8B,EAAE,iCAAiC;AACnE;;AAEA,WAAW;AACX;EACE,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;AACE;IACE,UAAU;IACV,QAAQ;AACV;AACF","sourcesContent":["<template>\r\n  <div>\r\n    <!-- Modal Overlay -->\r\n    <div class=\"modal-overlay\" @click=\"closeModal\"></div>\r\n\r\n    <!-- Modal Content -->\r\n    <div\r\n      class=\"modal-form rounded shadow modal-dialog\"\r\n      :class=\"[sizeClass, animationClass]\"\r\n    >\r\n      <div class=\"d-flex flex-column bg-white\">\r\n        <!-- Modal Header -->\r\n        <div v-if=\"!hideHeader\" class=\"d-flex justify-content-between bg-light p-3 align-items-center\">\r\n          <div class=\"modal-title mb-0\">\r\n            <slot name=\"title\" />\r\n          </div>\r\n          <a\r\n            class=\"no-hover cursor-pointer no-hover-color color-black primary-close-circle\"\r\n            @click.prevent=\"$emit('hideModal')\"\r\n          >\r\n            <em class=\"primaryicon-times\" />\r\n          </a>\r\n        </div>\r\n\r\n        <!-- Modal Body -->\r\n        <div class=\"modal-body p-3\">\r\n          <slot />\r\n        </div>\r\n\r\n        <!-- Modal Footer -->\r\n        <div v-if=\"!hideFooter\" class=\"modal-footer p-3\">\r\n          <slot name=\"footer\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script setup>\r\nimport { computed, ref, onMounted } from \"vue\";\r\n\r\nconst props = defineProps({\r\n  size: {\r\n    type: String,\r\n    required: false,\r\n    default: \"medium\", // Default size\r\n  },\r\n  hideFooter: {\r\n    type: Boolean,\r\n    required: false,\r\n    default: false,\r\n  },\r\n  hideHeader: {\r\n    type: Boolean,\r\n    required: false,\r\n    default: false,\r\n  },\r\n});\r\n\r\nconst emit = defineEmits([\"hideModal\"]);\r\n\r\nconst closeModal = () => {\r\n  emit(\"hideModal\");\r\n};\r\n\r\nconst sizeClass = computed(() => {\r\n  const sizes = {\r\n    small: \"modal-sm\",\r\n    medium: \"modal-md\",\r\n    large: \"modal-lg\",\r\n    \"extra-large\": \"modal-xl\",\r\n    \"extra-extra-large\": \"modal-xxl\",\r\n    full: \"modal-full\",\r\n  };\r\n  return sizes[props.size] || sizes;\r\n});\r\n\r\nconst animationClass = ref(\"\");\r\n\r\nonMounted(() => {\r\n  // Trigger the slide-down animation when the modal is mounted\r\n  setTimeout(() => {\r\n    animationClass.value = \"animate-modal\";\r\n  }, 100);\r\n});\r\n</script>\r\n\r\n<style scoped>\r\n/* Modal Overlay */\r\n.modal-overlay {\r\n  z-index: 150;\r\n  position: fixed;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: 100vw;\r\n  height: 100vh;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n/* Modal Form */\r\n.modal-form {\r\n  z-index: 200;\r\n  position: fixed;\r\n  top: 5%;\r\n  left: 50%;\r\n  max-width: 300px;\r\n  width: 100%;\r\n  min-height: fit-content;\r\n  max-height: 90vh; /* Prevent modal from exceeding viewport height */\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  pointer-events: unset;\r\n  opacity: 0; /* Initially hidden for animation */\r\n  transform: translateY(-50px) translateX(-50%);\r\n  transition: opacity 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n/* Smooth Slide Animation */\r\n.animate-modal {\r\n  opacity: 1; /* Fade in */\r\n  transform: translateY(0) translateX(-50%); /* Slide in from top */\r\n}\r\n\r\n/* Modal Sizes */\r\n\r\n/* Small modal */\r\n.modal-sm {\r\n  max-width: 300px;\r\n}\r\n\r\n/* Medium modal */\r\n.modal-md {\r\n  max-width: 500px;\r\n}\r\n\r\n/* Large modal */\r\n.modal-lg {\r\n  max-width: 800px;\r\n}\r\n\r\n/* Extra large modal */\r\n.modal-xl {\r\n  max-width: 1000px;\r\n}\r\n\r\n/* Extra extra large modal */\r\n.modal-xxl {\r\n  max-width: 1200px;\r\n}\r\n\r\n/* Full screen modal */\r\n.modal-full {\r\n  max-width: calc(100% - 15px);\r\n  height: auto;\r\n}\r\n\r\n/* Media queries to adjust modal sizes based on viewport width */\r\n@media (min-width: 576px) {\r\n  .modal-sm {\r\n    max-width: 400px; /* Adjust width for small devices */\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .modal-lg {\r\n    max-width: 1000px; /* Adjust width for large devices */\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .modal-xl {\r\n    max-width: 1200px; /* Adjust width for extra large devices */\r\n  }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n  .modal-xxl {\r\n    max-width: 1400px; /* Adjust width for extra extra large devices */\r\n  }\r\n\r\n}\r\n\r\n/* Scrollable Content */\r\n.modal-body {\r\n  flex: 1; /* Makes the body grow as needed */\r\n  overflow-y: auto; /* Enables scrolling if content is too large */\r\n  max-height: calc(90vh - 120px); /* Adjust for header and footer */\r\n}\r\n\r\n/* Footer */\r\n.modal-footer {\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n/* Responsive Adjustments */\r\n@media (max-width: 576px) {\r\n  .modal-form {\r\n    width: 90%;\r\n    top: 10%;\r\n  }\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
